/**
 * UI value formatters — tiny presentational helpers shared across windows.
 *
 * Keep this a pure leaf (no theme/engine imports) so any UI surface can pull a
 * formatter without dragging dependencies in.
 */

/**
 * Format a gold AMOUNT for display: a 💰-prefixed, thousands-separated string.
 *
 * This is the single source of truth for gold-AMOUNT glyph + grouping across
 * the NPC/economy UI (shop, services, quest rewards, inventory, trade). Item
 * PRICE tags rendered by ItemKit use a different glyph (🪙) and concept and are
 * intentionally NOT routed through here.
 */
export function formatGold(n: number): string {
  return `💰 ${n.toLocaleString()}`;
}
